import React from "react";
import { nanoid } from "nanoid";
import move from "frontend/src/lib/move";
import { findLastIndex } from "frontend/src/lib/findLastIndex";
var mapTracksToEntries = function (tracks) {
    return tracks.map(function (track) { return ({ id: nanoid(), track: track }); });
};
export var usePlaylistTracksEdit = function (initial) {
    var _a = React.useState(mapTracksToEntries(initial)), entries = _a[0], setEntries = _a[1];
    var tracks = React.useMemo(function () { return entries.map(function (entry) { return entry.track; }); }, [
        entries,
    ]);
    var setEntriesFromTracks = function (payload) {
        return setEntries(mapTracksToEntries(payload));
    };
    var reorder = React.useCallback(function (from, to) { return setEntries(move(entries, from, to)); }, [entries, setEntries]);
    var removeByIndex = React.useCallback(function (idx) { return setEntries(entries.filter(function (_, index) { return index !== idx; })); }, [entries, setEntries]);
    var removeLastById = React.useCallback(function (id) {
        var index = findLastIndex(entries, function (entry) { return entry.track.id === id; });
        if (index !== -1) {
            removeByIndex(index);
        }
    }, [entries, removeByIndex]);
    var add = React.useCallback(function (track) {
        setEntries(entries.concat({ id: nanoid(), track: track }));
    }, [entries, setEntries]);
    var addMany = React.useCallback(function (tracks) {
        setEntries(entries.concat(tracks.map(function (track) { return ({ id: nanoid(), track: track }); })));
    }, [entries, setEntries]);
    return {
        value: entries,
        set: setEntriesFromTracks,
        add: add,
        addMany: addMany,
        reorder: reorder,
        remove: { byIndex: removeByIndex, byIdLast: removeLastById },
        tracks: tracks,
    };
};
